import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useCheckUserRole } from '../hooks/useCheckUserRole';

function Editor() {
    const [blogs, setBlogs] = useState([]);
    const [authors, setAuthors] = useState([]); // Author listesi
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [selectedAuthor, setSelectedAuthor] = useState(''); // Seçilen yazar
    const [isLoading, setIsLoading] = useState(true); // Loading state
    const [isLoggedIn, setIsLoggedIn] = useState(localStorage.getItem('isLoggedIn') === 'true');
    const [userRole, setUserRole] = useState(localStorage.getItem('userRole')); // Kullanıcının rolünü al
    const navigate = useNavigate();
    const sectionRef = useRef(null);

    useCheckUserRole(['admin', 'editor', 'user', 'wait']);

    useEffect(() => {
        const storedIsLoggedIn = localStorage.getItem('isLoggedIn') === 'true';
        setIsLoggedIn(storedIsLoggedIn);
        setUserRole(localStorage.getItem('userRole')); // Kullanıcının rolünü güncelle

        if (!storedIsLoggedIn) {
            navigate('/login');  // Kullanıcı giriş yapmamışsa login sayfasına yönlendirilir
        }

        // Yalnızca 'wait' dışındaki roller için blogları çekiyoruz
        if (userRole !== 'wait') {
            setIsLoading(true); // Start loading
            fetch(`/api/blogs?page=${currentPage}&per_page=12&author=${selectedAuthor}`)
                .then(response => response.json())
                .then(data => {
                    setBlogs(data.blogs);
                    setTotalPages(data.pages);
                    setIsLoading(false); // End loading
                })
                .catch(error => {
                    console.error('Error fetching blog data:', error);
                    setIsLoading(false); // End loading in case of error
                });

            fetch('/api/authors')
                .then(response => response.json())
                .then(data => setAuthors(data.authors))
                .catch(error => console.error('Error fetching authors:', error));
        }
    }, [currentPage, selectedAuthor, navigate, userRole]);

    // Kullanıcı giriş yapmamışsa login sayfasına yönlendir
    useEffect(() => {
        if (!isLoggedIn) {
            navigate('/login');
        }
    }, [isLoggedIn, navigate]);

    // Sayfa değiştikçe yukarı kaydırma
    useEffect(() => {
        if (sectionRef.current) {
            sectionRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    }, [currentPage]);

    // Sayfa değişim işlemleri
    const handleNextPage = () => {
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        }
    };

    const handlePreviousPage = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };

    const handleAuthorChange = (event) => {
        setSelectedAuthor(event.target.value); // Filtrelenen yazarı seç
        setCurrentPage(1); // Sayfayı sıfırla
    };

    return (
        <>
            <div className="breadcrumb-section breadcrumb-bg">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-8 offset-lg-2 text-center">
                            <div className="breadcrumb-text">
                                <p></p>
                                <h1>Editör</h1>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="latest-news pt-150 pb-150" ref={sectionRef}>
                <div className="custom-container">
                    {userRole === 'wait' ? ( // Eğer kullanıcı 'wait' rolünde ise satın alma mesajı göster
                        <div className="text-center">
                            <h2>Bu içeriği görüntüleyebilmek için üyelik satın almanız gerekmektedir.</h2>
                            <button className="btn btn-primary" onClick={() => navigate('/satinal')}>
                                Üyelik Satın Al
                            </button>
                        </div>
                    ) : (
                        <>
                            {/* Loader */}
                            {isLoading ? (
                                <div className="loader">
                                    <div className="loader-inner">
                                        <div className="circle"></div>
                                    </div>
                                </div>
                            ) : (
                                <>
                                    <div className="row">
                                        <div className="col-lg-8 offset-lg-2 text-center">
                                            <div className="section-title">
                                                <h3><span className="orange-text">Editörlerimizin</span> Seçtikleri</h3>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Yazar Filtreleme Dropdown */}
                                    <div className="row mb-4">
                                        <div className="col-lg-4 text-center" style={{ marginLeft: 'auto' }}>
                                            <select value={selectedAuthor} onChange={handleAuthorChange} className="form-control">
                                                <option value=''>Tüm Yazarlar</option>
                                                {authors.map((author) => (
                                                    <option key={author} value={author}>{author}</option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>

                                    <div className="row">
                                        {blogs.map(blog => (
                                            <div key={blog.id} className="col-12 col-sm-6 col-md-4 col-custom-lg">
                                                <div className="single-latest-news">
                                                    <div className="news-text-box">
                                                        <a className='blogdetail' href={`/assets/kupon/${blog.image_filename}`} target="_blank" rel="noopener noreferrer">
                                                            <img src={`/assets/kupon/${blog.image_filename}`} alt={blog.blogname} />
                                                        </a>
                                                        <Link to={`/blog/${blog.id}`}>
                                                            <h3>{blog.blogname}</h3>
                                                            <p className="blog-meta">
                                                                <span className="author"><i className="fas fa-user"></i> {blog.author}</span>
                                                                <span>Yorum Yap</span>
                                                                <span className="date">
                                                                    <i className="fas fa-calendar"></i>
                                                                    {new Date(blog.date).toLocaleString("tr-TR", {
                                                                        day: "2-digit",
                                                                        month: "2-digit",
                                                                        year: "numeric",
                                                                        hour: "2-digit",
                                                                        minute: "2-digit",
                                                                    })}
                                                                </span>                                                             </p>
                                                            <p className="excerpt">{blog.feedback}</p>
                                                        </Link>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>

                                    <div className="pagination">
                                        <button onClick={handlePreviousPage} disabled={currentPage === 1}>Önceki</button>
                                        <span>Sayfa {currentPage} / {totalPages}</span>
                                        <button onClick={handleNextPage} disabled={currentPage === totalPages}>Sonraki</button>
                                    </div>
                                </>
                            )}
                        </>
                    )}
                </div>
            </div>
        </>
    );
}

export default Editor;
